import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { EmoticonNeutral } from 'src/ui/icons';

export const Card = styled.div`
  background: ${p => p.theme.bg.secondary};
  padding: ${layout.measurements.spacing150};

  &:not(:last-of-type) {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

type TextProps = {
  width: number;
};

export const Text = styled.div<TextProps>`
  width: ${p => p.width}%;
  height: 16px;
  margin-bottom: 6px;
  background: ${p => p.theme.colors.staticBase200};
  border-radius: 4px;
`;

export const Rating = styled.div`
  color: ${p => p.theme.colors.staticBase200};
`;

export const Smiley = styled(EmoticonNeutral).attrs(p => ({
  color: p.theme.colors.staticBase400,
}))`
  background: ${p => p.theme.colors.staticBase200};
  border-radius: 8px;
`;
